/**
 * we use this to re-evaluate the language each time the function is called
 * this is useful for testing
 */
export const getLanguage = () => navigator.language || 'en-US';
